import React from "react";
import "./PrivacyPolicy.css";
import BackBtn from "../../Components/BackBtn/BackBtn";

const PrivacyPolicy = () => {
    return (
        <div className="privacy-container">
            <div className="contact-header">
                <div className="cnct-back-btn">
                    <BackBtn />
                </div>
                <div className="cnct-header-cnt">
                    <h1>Privacy Policy</h1>
                </div>
            </div>
            <p><strong>Effective Date: September 1, 2015</strong></p>

            <p>
                Because We Can Sports ("we," "us," or "our") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose,
                and safeguard your information when you visit our website, https://www.bwcsports.com (the "Site"), and how we use tracking technologies like
                Facebook pixels. Please read this policy carefully to understand our practices regarding your information and how we will treat it. By using the
                Site, you agree to the collection and use of your information in accordance with this Privacy Policy.
            </p>

            <h2>1. Information We Collect</h2>
            <p>We collect information from you in various ways when you use the Site, including:</p>
            <ul>
                <li><strong>Personal Information:</strong> This includes your name, email address, mailing address, phone number, and other information you provide
                    directly when registering for services, subscribing to newsletters, or making purchases.</li>

                <li><strong>Non-Personal Information:</strong> This includes automatically collected information such as your IP address, browser type, operating system,
                    device information, and browsing history (pages viewed, links clicked, etc.) when you access the Site.</li>

                <li><strong>Cookies and Tracking Technologies:</strong> We use cookies, web beacons, and similar tracking technologies to collect information. This helps us
                    understand how you interact with the Site and improve our services.</li>
            </ul>

            <h2>2. How We Use Your Information</h2>
            <p>The information we collect from you is used to:</p>
            <ul>
                <li>Operate, protect, and maintain our services.</li>
                <li>Process your transactions and send you related information, including purchase confirmations and invoices.</li>
                <li>Communicate with you, including sending you marketing materials, updates, and newsletters (with your consent).</li>
                <li>Analyze website usage and improve our services.</li>
                <li>Use for advertising and retargeting purposes, including through Facebook pixels and other tracking tools.</li>
            </ul>

            <h2>3. Facebook Pixel and Other Tracking Tools</h2>
            <p>We use Facebook Pixel and other third-party tracking tools (such as Google Analytics) to collect data about your interactions with our website.
                This helps us understand visitor behavior and optimize the Site. This includes:</p>
            <ul>
                <li><strong>Analytics:</strong> We use data to improve the performance of our business and our Site.</li>
                <li><strong>Remarketing:</strong> We use data to serve personalized ads to you on platforms like Facebook and Instagram based on your website activity.</li>
            </ul>
            <p>You can opt out of Facebook Pixel tracking through your settings on Facebook or via www.aboutads.info/choices to opt-out of third-party data collection.</p>

            <h2>4. Sharing Your Information</h2>
            <p>We do not sell your personal information to third parties. However, we may share your information with trusted third parties in the following situations:</p>
            <ul>
                <li><strong>Service Providers:</strong> We may share your information with service providers who help us operate the Site, such as hosting companies,
                    email service providers, or payment processors.</li>

                <li><strong>Business Transfers:</strong> In the event of a merger, sale, or transfer of all or part of our business, we may share or transfer your
                    personal information as part of the transaction.</li>

                <li><strong>Legal Compliance:</strong> We may disclose your information if required by law or in response to a valid legal request (such as a subpoena or
                    court order).</li>
            </ul>

            <h2>5. Your Rights and Choices</h2>
            <p>You have the following rights regarding your personal information:</p>
            <ul>
                <li><strong>Access:</strong> You can request access to your personal data that we have collected.</li>
                <li><strong>Correction:</strong> You can request that we correct any inaccurate or incomplete personal data.</li>
                <li><strong>Deletion:</strong> You can request that we delete your personal data, though we may need to retain certain information for legal or business purposes.</li>
                <li><strong>Opt-Out:</strong> You can opt-out of receiving marketing emails by following the unsubscribe link in our emails.</li>
            </ul>
            <p>For any of the above requests, please contact us at https://www.bwcsports.com</p>

            <h2>6. Security</h2>
            <p>We take the security of your personal information seriously and implement reasonable security measures to protect it. However, no method of
                transmission over the internet or electronic storage is 100% secure, and we cannot guarantee absolute security.</p>

            <h2>7. Third-Party Links</h2>
            <p>The Site may contain links to third-party websites that are not controlled by us. We are not responsible for the privacy practices or content of these
                external websites. We recommend reviewing the privacy policies of any third-party sites you visit.</p>

            <h2>8. Children's Privacy</h2>
            <p>Our services are not directed to children under the age of 13. We do not knowingly collect personal information from children under 13. If we become
                aware that we have inadvertently collected such information, we will take steps to delete it.</p>

            <h2>9. Changes to This Privacy Policy</h2>
            <p>We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page with a new
                effective date. Please check this page periodically to stay informed of any updates.</p>

            <h2>10. Contact Us</h2>
            <p><strong>Please be advised that all purchases are final. All sales are non-refundable and non-transferable.</strong></p>
            <p>If you have any questions or concerns about this Privacy Policy, please contact us at:</p>
            <p>
                Because We Can Sports<br />
                becausewecansports@gmail.com<br />
                1-347-212-0028
            </p>
        </div>
    );
};

export default PrivacyPolicy;
